import { createSlice } from "@reduxjs/toolkit";
import { uploadWork } from "./workService";

// Initial state
const initialState = {
  works: [],
  currentWork: null,
  loading: false,
  error: null,
};

// Work slice
const workSlice = createSlice({
  name: "work",
  initialState,
  reducers: {
    clearWorkErrors: (state) => {
      state.error = null;
    },
    clearWorkData: (state) => {
      state.works = [];
      state.currentWork = null;
      state.loading = false;
      state.error = null;
    },
    setCurrentWork: (state, action) => {
      state.currentWork = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Upload Work
    builder
      .addCase(uploadWork.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadWork.fulfilled, (state, action) => {
        state.loading = false;
        state.works = [...state.works, action.payload.data];
        state.currentWork = action.payload.data;
      })
      .addCase(uploadWork.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearWorkErrors, clearWorkData, setCurrentWork } =
  workSlice.actions;
export default workSlice.reducer;
